import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Navigation, Thumbs } from "swiper/modules";

document.querySelectorAll(".component-photo-gallery").forEach((el) => {
  const mainContainer = el.querySelector(".main-gallery .swiper");
  const thumbContainer = el.querySelector(".thumb-gallery .swiper");
  const numSlides = mainContainer.querySelectorAll(".swiper-slide").length;

  if (numSlides > 1) {
    const thumbSwiper = new Swiper(thumbContainer, {
      slidesPerView: "auto",
      spaceBetween: 12,
      preloadImages: false,
      watchSlidesProgress: true,
      threshold: 20,
      loop: true,
      breakpoints: {
        1280: {
          direction: "vertical",
        },
      },
    });

    new Swiper(mainContainer, {
      modules: [A11y, Autoplay, EffectFade, Navigation, Thumbs],
      slidesPerView: 1,
      speed: 750,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      preloadImages: false,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: el.querySelector(".slider-button-next"),
        prevEl: el.querySelector(".slider-button-prev"),
      },
      thumbs: {
        multipleActiveThumbs: false,
        swiper: thumbSwiper,
      },
    });
  }
});
